import { KeepAwake } from '@capacitor-community/keep-awake';

export class KeepDeviceAwake {

  static async keepAwake() {
    // WakeLock 은 탭이 백그라운드(비가시)면 NotAllowedError 를 던진다 — 편의 기능이
    // 호출측 흐름(통화 시작 등)을 죽이면 안 되므로 실패는 삼킨다 (실측: 백그라운드
    // 탭에서 통화 시작이 통째로 중단되던 잠복 버그)
    try {
      if (await this.isSupported()) {
        await KeepAwake.keepAwake();
        console.log('Keeping device awake');
      } else {
        console.log('This browser does not support keep awake.')
      }
    } catch (e) {
      console.warn('keepAwake 실패(무시):', e);
    }
  }

  static async allowSleep() {
    try {
      if (await this.isSupported()) {
        console.log('Allow device to sleep');
        await KeepAwake.allowSleep();
      }
    } catch (e) {
      console.warn('allowSleep 실패(무시):', e);
    }
  }

  static async isSupported() {
    const result = await KeepAwake.isSupported();
    return result.isSupported;
  }
}